module.exports = __webpack_public_path__ + "img/6127ed8.svg";